import { Layers } from "appworks/graphics/layers/layers";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Text } from "appworks/graphics/pixi/text";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { Contract } from "appworks/utils/contracts/contract";
import { GamevyFreeGamesComponent } from "gamevy/components/gamevy-freegames-component";
import { gamevyModel } from "gamevy/gamevy-model";

export class EpicGamevyFreegamesComponent extends GamevyFreeGamesComponent {
    protected overridePosition: string = "override_position";

    public init() {

        Layers.get("BetBar").onSceneEnter.add((scene) => {
            if (scene === "minimal") {
                Layers.get("Freegames").hide();
            } else {
                Layers.get("Freegames").show();
            }
        });

        Layers.get("Freegames").onSceneEnter.add(() => {
            this.updatePosition();
        });

        super.init();
    }

    public begin() {
        this.layer = Layers.get("Freegames");

        // Turn off free games scene until popup is gone
        Layers.get("Freegames").defaultScene().execute();

        return super.begin();
    }

    public update() {
        const freegames: number = gamevyModel.getTotalFreeGames();
        if (freegames > 0) {
            uiFlags.set(UIFlag.FREE_BETS, true);
            Layers.get("Freegames").setScene("base").execute();
            this.showBetBarElements();
        }

        return super.update();
    }

    public setOverridePosition(positionName: string) {
        this.overridePosition = positionName;
        Layers.get("Freegames").defaultScene().execute();

        const paused = this.paused;
        if (this.paused) {
            this.paused = false;
        }

        this.update().execute();

        this.paused = paused;
    }

    protected end(): Contract<void> {
        uiFlags.set(UIFlag.FREE_BETS, false);
        Layers.get("Freegames").defaultScene().execute();

        return super.end();
    }

    private showBetBarElements() {
        const betBar = Layers.get("Freegames");

        const freegameText = [
            "gamevy_free_games_label",
            "gamevy_free_games_total_value",
            "gamevy_free_games_count_value"
        ];

        const showText = (name: string, visible: boolean) => {
            const text = betBar.getText(name);
            if (text) {
                text.visible = visible;
            }
        };

        if (betBar.getSprite("gamevy_free_games_asset")) {
            betBar.getSprite("gamevy_free_games_asset").visible = true;
        }

        freegameText.forEach((name) => showText(name, true));
    }

    private updatePosition(): void {
        const layer = Layers.get("Freegames");
        const landscape = layer?.getPosition(this.overridePosition)?.landscape;
        const portrait = layer?.getPosition(this.overridePosition)?.portrait;

        if (layer && landscape && portrait) {
            const updatePosition = (element: Sprite | Text) => {
                if (element) {
                    element.landscape.x = landscape.x + element.landscape.x;
                    element.landscape.y = landscape.y + element.landscape.y;
                    element.portrait.x = portrait.x + element.portrait.x;
                    element.portrait.y = portrait.y + element.portrait.y;
                }
            };

            layer.container.children.forEach((child) => {
                if (child instanceof Sprite || child instanceof Text) {
                    updatePosition(child);
                }
            });
        }
    }
}
